module.exports = __webpack_public_path__ + "img/routing.a86bfee1.png";